import React, { useEffect, useState, useRef } from 'react';
import "./Header.css";

import MapItButton from '../../Common/MapItButton/MapItButton';

import { Link, useNavigate } from 'react-router-dom';

import account_icon from '../../../Assets/UserPictureIcon-48x48.png';

const Header = ({file, create, setCreate, user, setUser, setRegMode, setEmail}) => {
  const [showAccList, setShowAccList] = useState(false);
  const menuRef = useRef();
  const iconRef = useRef();
  let navigate = useNavigate();

  const sub_map = {
    0: "Single Plan",
    1: "Professional",
    2: "Professional"
  }

  useEffect(() => {
    const closePopup = (e) => {
      if (menuRef.current && iconRef.current 
        && !menuRef.current.contains(e.target)
        && !iconRef.current.contains(e.target)) {
          setShowAccList(false);
      }
    }
    document.body.addEventListener('mousedown', closePopup);
    return () => {
      document.body.removeEventListener('mousedown', closePopup);
    };
  }, []);

  const onDelSS = () => {
    console.log("snapshot del pressed");
    // setSSDelActi(false);
  }

  const onCanDelSS = () => {
    console.log("snapshot cancel pressed");
    // setSSDelActi(false);
  }

  const onLogout = () => {
    // localStorage.setItem("user", "");
    setCreate(false);
    setShowAccList(false);
    setUser({});
    setEmail("");
    navigate("/login");
  }

  const onLogin = () => {
    setCreate(false);
    setRegMode(false);
  }

  return(
  <div>
    <div className={file?"c-banner":"banner"}>
    <div className="dMapIt-logo-div">
      <Link to="/" spy={true} smooth={true}>
        <img 
        src="https://d13dvi4jdbb8bg.cloudfront.net/MapIt-Logo-768x292px.png" 
        width="157.81vh" 
        height="60vh"
        alt="MapIt logo"/>
      </Link>
    </div>
    <div className="Spacer1"></div>
      <div className="Menu">
        <div className='menu-item-div'>
          <p onClick={() => setCreate(false)} className="Menu-item">
            {!user || (user && Object.keys(user).length === 0)
            ?
            <Link className="Link-style" to="/" spy={true} smooth={true}>Home</Link>
            :
            <Link className="Link-style" to="/projectview" spy={true} smooth={true}>Projects</Link>
            }
          </p>
        </div>
        <div className='menu-item-div'>
          <p onClick={() => setCreate(false)} className="Menu-item">
          <Link className="Link-style" to="/industries" spy={true} smooth={true}>Use Cases</Link>
          </p>
        </div>
        {/* <div>
          <p onClick={() => setCreate(false)} className="Menu-item">
          <Link className="Link-style" to="/download" spy={true} smooth={true}>Download</Link>
          </p>
        </div> */}
        <div className='menu-item-div'>
          <p onClick={() => setCreate(false)} className="Menu-item">
          <Link className="Link-style" to="/contact" spy={true} smooth={true}>Contact</Link>
          </p>
        </div>
        <div className='menu-item-div'>
          <p onClick={() => setCreate(false)} className="Menu-item">
          <Link className="Link-style" to="/pricing" spy={true} smooth={true}>Pricing</Link>
          </p>
        </div>
        <div className="create-btn-div">
          <p onClick={() => setCreate(true)} className="Menu-item">
          <Link className="Link-style-create" to="/create" spy={true} smooth={true}>
            <MapItButton onSubmit={()=>{}} text="Create" className="createBtn"></MapItButton>
          </Link>
          </p>
        </div>
        {/* <div>
          <p className="Menu-item">
            Login
          </p>
        </div> */}
      </div>  
    <div className="Spacer2"></div>
    {!user || Object.keys(user).length === 0
    ?
    <div className="login-signup-div">
    <div className='menu-item-div'>
        <p onClick={() => onLogin()} className="Menu-item">
        <Link className="Link-style" to="/login" spy={true} smooth={true}>Log In</Link>
        </p>
    </div>
    <div className='menu-item-div2'>
        <p onClick={() => setCreate(false)} className="Menu-item">
        <Link className="Link-style" to="/login" spy={true} smooth={true}>
          <MapItButton onSubmit={() => setRegMode(true)} text="Sign Up" className="signup-mapitBtn"></MapItButton>
        </Link>
        </p>
    </div>
    </div>
    :
    <div ref={iconRef} className='account-div'>
      <div>
        <img 
          src={account_icon} 
          width="36"
          height="36"
          onClick={() => setShowAccList(!showAccList)} 
          alt="account icon"
        />
      </div>
    </div>
    }
    </div>
    {showAccList &&
      <div ref={menuRef} className="acc-tree">
        <div className="acc-tree-inner">
        <div className="acc-details">
          <div className="acc-name">
            <p className="name-item">
              {user.first_name} {user.last_name}
            </p>
            <p className="email-item">
              {user.email}
            </p>
          </div>
        </div>
        <hr className="hr-acc"></hr>
        <div className="acc-sub">
          <div className="acc-name">
            <p className="email-item">
              Subscription Plan: {sub_map[user.sub_plan]}
            </p>
            {user.sub_cancel_pending &&
            <div className="acc-name">
              <p className="email-item">Cancellation Date: {user.sub_cancel_pending} </p>
            </div>
            }
          </div>
        </div>
        <hr className="hr-acc"></hr>
        <div className="acc-function">
          <p onClick={() => onLogout()} className="logout-item">
            Log Out
          </p>
        </div>
      </div>
      </div>
    }   
  </div>
  );
}

export default Header;

